/** Database of applications with Premium Loading/ CBE/ declined status */
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import {
	getLoadingsRatioTotal,
	getLoadingCode,
	getExclusionCode,
	getRejectionCode
} from "./helpers.js"

import dayjs from "dayjs"

const header = [
	[
		"Template 04 - Database of applications with Premium Loading/ CBE/ declined status "
	],
	[
		"VHIS Cert No.",
		"Age",
		"Sex",
		"Underwriting/ Re-underwriting result",
		"Level of Premium Loading Rate (%)",
		"Reason for Premium Loading 1",
		"Reason for Premium Loading 2",
		"Reason for Premium Loading 3",
		"Reason for Premium Loading 4",
		"Reason for Premium Loading 5",
		"Reason for CBE 1",
		"Reason for CBE 2",
		"Reason for CBE 3",
		"Reason for CBE 4",
		"Reason for CBE 5",
		"Reason for Decline 1",
		"Reason for Decline 2",
		"Reason for Decline 3",
		"Reason for Decline 4",
		"Reason for Decline 5"
	]
]

// Return calculated age
const getAge = item => {
	const dateOfBirth = item?.insureds?.[0]?.dateOfBirth
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = cases => {
	let output = []
	cases.map(item => {
		item?.proposals?.map(proposal => {
			const underwritingResult = getUnderwritingResult(proposal)
			const loadings = proposal?.basket?.[0]?.premium?.loadings
			const exclusions = proposal?.basket?.[0]?.exclusions
			const rejectionCodes = proposal?.rejectionCodes

			if (underwritingResult !== null) {
				output.push([
					proposal?.basket?.[0]?.product?.productId?.plan,
					getAge(item),
					item?.insureds?.[0]?.gender,
					getUnderwritingResult(proposal),
					getLoadingsRatioTotal(loadings) * 100,
					getLoadingCode(loadings, 0),
					getLoadingCode(loadings, 1),
					getLoadingCode(loadings, 2),
					getLoadingCode(loadings, 3),
					getLoadingCode(loadings, 4),
					getExclusionCode(exclusions, 0),
					getExclusionCode(exclusions, 1),
					getExclusionCode(exclusions, 2),
					getExclusionCode(exclusions, 3),
					getExclusionCode(exclusions, 4),
					getRejectionCode(rejectionCodes, 0),
					getRejectionCode(rejectionCodes, 1),
					getRejectionCode(rejectionCodes, 2),
					getRejectionCode(rejectionCodes, 3),
					getRejectionCode(rejectionCodes, 4)
				])
			}
		})
	})
	return output
}

const getUnderwritingResult = proposal => {
	const status = proposal?.status
	const hasLoadings =
		proposal?.basket?.[0]?.premium?.loadings?.length > 0 ? true : false
	const hasExclusions =
		proposal?.basket?.[0]?.exclusions?.length > 0 ? true : false

	if (status === "REJECTED") return "Decline"
	else if (
		status !== "REJECTED" &&
		hasLoadings === true &&
		hasExclusions === false
	)
		return "Offer with Premium Loading only"
	else if (
		status !== "REJECTED" &&
		hasLoadings === false &&
		hasExclusions === true
	)
		return "Offer with CBE only"
	else if (
		status !== "REJECTED" &&
		hasLoadings === true &&
		hasExclusions === true
	)
		return "Offer with Premium Loading and CBE only"
	else return null
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate04Payload($caseWhere: caseWhere) {
			cases(where: $caseWhere) {
				list {
					id
					insureds {
						... on individual {
							dateOfBirth
							gender
						}
					}
					proposals {
						id
						status
						rejectionCodes {
							code
							name
						}
						basket {
							product {
								productId {
									plan
								}
							}
							premium {
								loadings {
									id
									codeName {
										code
										name
									}
									ratio
								}
							}
							exclusions {
								id
								codeName {
									code
									name
								}
							}
						}
					}
				}
			}
		}
	`

	const variables = {
		caseWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.cases?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = [
		{ wpx: 150 },
		{ wpx: 50 },
		{ wpx: 50 },
		{ wpx: 300 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
